<template>
  <div class="data vh-100 pl-3 pr-3 d-flex justify-content-center align-items-center">
    <div class="container">
      <div class="row">
        <div class="col-sm-6 d-flex align-items-center justify-content-center">
          <img
              src="../../assets/img/imac.png"
              class="img-fluid"
              data-aos="fade-right"
              data-aos-duration="1000"
              data-aos-once="false"
          />
        </div>
        <div class="col-sm-6 p-5 text-center d-flex flex-column align-items-center justify-content-center">
          <h1 class="title text-white">
            Al je gegevens, altijd beschikbaar, op al je devices
          </h1>
          <div class="sub-title text-white">
            SimpleFinance is een app in de cloud. Zo kan je altijd en overal bij je gegevens, ook op je
            telefoon en tablet. Daarnaast versleutelen we het dataverkeer en de bestanden zodat niemand
            anders daar bij kan komen.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Data'
};
</script>

<style scoped>
.data {
  min-height: 950px;
  background: linear-gradient(131deg, #FFC371, #DD2476);
  background-size: 120% 120%;
  animation: animatedbg 12s ease infinite;
  -webkit-clip-path: polygon(0 0, 100% 10%, 100% 100%, 0 100%);
  clip-path: polygon(0 0, 100% 10%, 100% 100%, 0 100%);
}
</style>
